import React from "react";
import FichePageH from "./FichePageH";
import LandingPage from "../LandingPage";
import { useOuvertureH } from "./ouverture";

/** L'accueil EST le produit. Le serveur garde la main sur le repli. */
export default function AccueilFiche() {
  const ouverture = useOuvertureH();
  if (ouverture === "inconnue") {
    return <p className="px-5 py-12" role="status">Préparation de votre espace…</p>;
  }
  return ouverture === "ouverte" ? <FichePageH accueil /> : <LandingPage />;
}
